import { c as _c } from "react/compiler-runtime";
import { Heading, HStack, Icon, VStack } from '@chakra-ui/react';
import { AppPanelToggleButton } from '@src/components/sco/AppLayout/Panel/AppPanelToggleButton.tsx';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import { CommentThread } from '@src/components/sco/Comments/CommentThread';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import React from 'react';
import { LuMessageCircle } from 'react-icons/lu';
type EducationNavProps = {};
export const EducationAside: React.FC<EducationNavProps> = props => {
  const $ = _c(5);
  const educationContext = useEducationContext();
  const activeItem = educationContext.activeContent?.item;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AppLayoutToolbar><HStack justify="space-between" width="full"><HStack><Icon as={LuMessageCircle} /><Heading size="sm">Comments</Heading></HStack><AppPanelToggleButton panelId="edu-aside" panelPosition="right" /></HStack></AppLayoutToolbar>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== activeItem) {
    t1 = activeItem && <CommentThread attachmentId={`${activeItem.id}`} attachmentType={activeItem.__typename || activeItem.type} composerBoxProps={{}} showBottomComposer={true} />;
    $[1] = activeItem;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SSRGate disableSSR={true}><VStack width="full">{t0}<VStack height="full" padding={3} width="full">{t1}</VStack></VStack></SSRGate>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};